interface LoadingOverlayProps {
  open?: boolean;
  label?: string;
}

export function LoadingOverlay({
  open = true,
  label = "Loading...",
}: LoadingOverlayProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40">
      <div className="w-28 h-28 rounded-2xl bg-white shadow-lg flex flex-col items-center justify-center gap-3">
        <div className="w-8 h-8 rounded-full border-[3px] border-gray-300 border-t-[#23A9C6] animate-spin" />
        <p className="text-xs text-gray-600">{label}</p>
      </div>
    </div>
  );
}
